export const BRAND_CARD_BENEFITS = ["card_1", "card_2", "card_3", "card_4", "card_5", "card_6"];
